// pc_common.js
/**!
 * lazysizes - v5.3.2
 * https://github.com/aFarkas/lazysizes
 * MIT License
 * Copyright (c) 2015 Alexander Farkas
 */
import "lazysizes";
import "lazysizes/plugins/aspectratio/ls.aspectratio"; // For Responsive, Smartphone(+ Desktop).CLS(Cumulative Layout Shift).
// import "lazysizes/plugins/unveilhooks/ls.unveilhooks.js"; // Used for backgrounds.
// import "lazysizes/plugins/parent-fit/ls.parent-fit";// lazySizes parent fit extension

/**
 * @license MIT
 * ua-parser-js@1.0.37
 * https://github.com/faisalman/ua-parser-js
 */
// fyi: https://hirakublog.com/user-agent-body-addclss/
import ua from "./modules/UserAgent";
ua.init();

/**
 * desvg - v1.0.2
 * https://github.com/benhowdle89/deSVG
 * ISC License
 * Copyright (c) 2016 Ben Howdle
 */
import "desvg";
window.addEventListener("load", function () {
 deSVG(".desvg", true);
});

// /**
//  * Page Animation / GSAP
//  */
// import * as pa from "./modules/gsapScrollAnimation";
// // pa.PageAnimationCommon();
// pa.showScrollTopButton();

/**
 * External Link / Vanilla Js
 * For Smartphone + Desktop Only
 */
import * as common from "./modules/external_link";
common.externalLink();

/**
 * CurrentCheck / Vanilla Js
 * For Smartphone + Desktop Only
 */
import CurrentCheck from "./modules/CurrentCheck";
CurrentCheck();

/**
 * Menu / Vanilla Js
 * For Smartphone + Desktop Only
 */
import ButtonHamburgerMenu from "./modules/ButtonHamburgerMenu";
ButtonHamburgerMenu();

/**
 * Smooth Anchor Scroll / Vanilla Js
 * For Smartphone + Desktop Only
 */
import SmoothAnchorScroll from "./modules/SmoothAnchorScroll";
SmoothAnchorScroll();

/**
 * Viewport Height / Vanilla Js
 * For Smartphone + Desktop Only
 */
import setViewportHeight from "./modules/ViewportHeight";
setViewportHeight();

/**
 * @license MIT
 * micromodal@0.4.10
 * https://github.com/ghosh/micromodal
 */
import MicroModal from "micromodal";
MicroModal.init({
 disableScroll: true,
 awaitOpenAnimation: true,
 awaitCloseAnimation: true,
 debugMode: true,
 disableFocus: true,
 //  onShow: (modal) => console.info(`${modal.id} is shown`),
 //  onClose: (modal) => console.info(`${modal.id} is hidden`),
});

/**
 * GA4 Click Tracker / Vanilla Js
 */
import { initCardModalDataAttributeSetter } from "./modules/ga4/cardModalDataAttributeSetter.js";
import { initGA4ClickTracker } from "./modules/ga4/clickTracker.js";
// DOMの読み込み後に初期化
document.addEventListener("DOMContentLoaded", () => {
 initCardModalDataAttributeSetter();
 initGA4ClickTracker();
});
